<template lang='pug'>
  #app(:class="langClass")
    //- MenuTop(ref="menu")
    keep-alive
      router-view(v-if="$route.meta.keepAlive")
    router-view(v-if="!$route.meta.keepAlive")
</template>

<script>
import "font-awesome/css/font-awesome.min.css"
import "./assets/fonts/fonts.css"

  export default {
    name: 'app',
    computed: {
      langClass(){
        return localStorage.getItem('lang') || 'zh_cn'
      }
    },
    mounted(){
    },
    methods:{
    }
  }
</script>
